/**
 * 通用js方法封装处理
 *
 */

const baseURL = process.env.VUE_APP_BASE_API

// 通用下载方法
export function download(fileName) {
  if (fileName.indexOf('http://') !== -1 || fileName.indexOf('https://') !== -1) window.open(fileName)
  else window.open(baseURL + fileName)
}
